import { render } from "./CdesMainUi.vue?vue&type=template&id=d03aa79c&ts=true"
import script from "./CdesMainUi.ts?vue&type=script&lang=ts&external"
export * from "./CdesMainUi.ts?vue&type=script&lang=ts&external"

import "./CdesMainUi.vue?vue&type=style&index=0&id=d03aa79c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__